// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateDirectHoldingsEntitiesMutationVariables = Types.Exact<{
  updateEntities: Array<Types.AugmentedUpdateEntityInput> | Types.AugmentedUpdateEntityInput;
}>;


export type UpdateDirectHoldingsEntitiesMutation = { __typename?: 'Mutation', updateEntities: Array<{ __typename?: 'Entity', id: string, integrationEntities?: Array<{ __typename?: 'IntegrationEntity', id: string, integrationID: string }> | null } | null> };

export const Operations = {
  Mutation: {
    UpdateDirectHoldingsEntities: 'UpdateDirectHoldingsEntities' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const UpdateDirectHoldingsEntitiesDocument = gql`
    mutation UpdateDirectHoldingsEntities($updateEntities: [AugmentedUpdateEntityInput!]!) {
  updateEntities(input: $updateEntities) {
    id
    integrationEntities {
      id
      integrationID
    }
  }
}
    `;
export type UpdateDirectHoldingsEntitiesMutationFn = Apollo.MutationFunction<UpdateDirectHoldingsEntitiesMutation, UpdateDirectHoldingsEntitiesMutationVariables>;

/**
 * __useUpdateDirectHoldingsEntitiesMutation__
 *
 * To run a mutation, you first call `useUpdateDirectHoldingsEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDirectHoldingsEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDirectHoldingsEntitiesMutation, { data, loading, error }] = useUpdateDirectHoldingsEntitiesMutation({
 *   variables: {
 *      updateEntities: // value for 'updateEntities'
 *   },
 * });
 */
export function useUpdateDirectHoldingsEntitiesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDirectHoldingsEntitiesMutation, UpdateDirectHoldingsEntitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDirectHoldingsEntitiesMutation, UpdateDirectHoldingsEntitiesMutationVariables>(UpdateDirectHoldingsEntitiesDocument, options);
      }
export type UpdateDirectHoldingsEntitiesMutationHookResult = ReturnType<typeof useUpdateDirectHoldingsEntitiesMutation>;
export type UpdateDirectHoldingsEntitiesMutationResult = Apollo.MutationResult<UpdateDirectHoldingsEntitiesMutation>;
export type UpdateDirectHoldingsEntitiesMutationOptions = Apollo.BaseMutationOptions<UpdateDirectHoldingsEntitiesMutation, UpdateDirectHoldingsEntitiesMutationVariables>;